<template>
  <div class="store-info">
    <h1>续费门店</h1>
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="storeName" label="门店">
        <template #default="{ row: { storeName } }">
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="storeName" placement="top">
            <span class="store-name">
              {{ storeName }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="storeManagerName" label="店长">
        <template #default="{ row: { storeManagerName } }">
          <span v-if="storeManagerName">{{ storeManagerName }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="oldContractEndTime" label="原年费服务到期时间"></el-table-column>
      <el-table-column prop="newContractEndTime" label="新年费服务到期时间"></el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
        @current-change="handlePageNo"
        @size-change="handlePageSize"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'storeInfo',
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      data: [],
      total: 1,
      pageNo: 1,
      pageSize: 10
    };
  },
  created() {
    this.getOrderLinkStoreList();
  },
  methods: {
    async getOrderLinkStoreList() {
      const { id, pageNo, pageSize } = this;
      const params = { id, pageNo, pageSize };
      const res = await Fetch.getOrderLinkStoreList(params);
      this.data = res.data;
      this.total = res.totalCount;
    },
    handlePageNo(pageNo) {
      this.pageNo = pageNo;
      this.getOrderLinkStoreList();
    },
    handlePageSize(pageSize) {
      this.pageSize = pageSize;
      this.getOrderLinkStoreList();
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  padding: 12px 0 10px 0;
}
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
    overflow-x: auto;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    min-width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
